import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import {
  DashboardCarrierStatitics,
  DashboardGiverStatitics,
  DashboardZoneSaturationFilters,
  DashboardZoneSaturationResponse,
} from './types';

export const DASHBOARD_ENPOINTS = {
  getDashboardCarrierStatitics: '/api/v1/Route/Report/DashboardCarrier',
  getDashboardGiverStatitics: '/api/v1/Route/Report/DashboardGiver',
  getZoneSaturation: '/api/v1/Route/Report/ZoneSaturation',
};

export const getDashboardCarrierStatitics = (): ApiPromise<
  DataResponse<DashboardCarrierStatitics>,
  ErrorResponse
> =>
  API.post<DataResponse<DashboardCarrierStatitics>, ErrorResponse>(
    DASHBOARD_ENPOINTS.getDashboardCarrierStatitics,
  );

export const getDashboardGiverStatitics = (): ApiPromise<
  DataResponse<DashboardGiverStatitics>,
  ErrorResponse
> =>
  API.post<DataResponse<DashboardGiverStatitics>, ErrorResponse>(
    DASHBOARD_ENPOINTS.getDashboardGiverStatitics,
  );

export const getZoneSaturation = (
  filters: DashboardZoneSaturationFilters,
): ApiPromise<DataResponse<DashboardZoneSaturationResponse>, ErrorResponse> =>
  API.post<DataResponse<DashboardZoneSaturationResponse>, ErrorResponse>(
    DASHBOARD_ENPOINTS.getZoneSaturation,
    filters,
  );
